export const PRICING_PREVIEW = `
	<p>We are excited to announce LaneMaster. A real time pricing service providing pricing estimates updated in real time as new transactions come in. </p>
	<p>The service will be coming online in the next few weeks and will be rolled out to customers on a first come first served basis. To get more info and pre-register, to get your place on the list, click the button below. </p>
	<div>
		<img src="../assets/images/pricing.png" width="100%">
	</div>
`;
